import czJson from '../../../assets/localization/cz.json';

export function translate(key: string, shouldFormat: boolean = false, ...parameters: any[]): string {
	if (!shouldFormat) {
		return prepareText(key);
	}

	const formattedParams = parameters.map(param => {
		if (typeof param === 'string' && czJson[param]) {
			return czJson[param];
		}
		return param;
	});

	return formatText(key, ...formattedParams);
}

export const prepareText = (key: string): string => {
	const cz = czJson as any;

	return cz && cz[key] ? cz[key] : key;
};

export const formatText = (key: string, ...parameters: any[]): string => {
	return prepareText(key).replace(/{(\d+)}/g, function(item: string, index) {
		return typeof parameters[index] !== 'undefined' ? parameters[index] : item;
	});
};

export const transformKeyToLowerCamelCase = (key: string): string => {
	return key.replace(/(^\w|[.]\w)/g, m => m.toLowerCase());
};
